module.exports = __webpack_public_path__ + "img/cake-4.7639895e.svg";